import i18n from "../../i18n";
import MenuState from "../../types/menu/MenuState";
import trackCustomGA4Event from "./trackCustomGA4Event";

const reportMenuDuration = (menuState: MenuState, menuNameOutsidePortal = "") => {
  const { activeItem, activeItemStartedAt, menu } = menuState;

  if (!activeItem || !activeItemStartedAt) return;

  const durationSeconds = Math.round((Date.now() - activeItemStartedAt) / 1000);

  if (durationSeconds <= 0) return;

  if (menuNameOutsidePortal !== "") {
    trackCustomGA4Event('time_spent_per_page', {
      menu_id: 0,
      menu_name: menuNameOutsidePortal,
      duration_seconds: durationSeconds,
      display_language: i18n.language
    });
    return;
  }
  // Top-level menu
  const topMenu = menu.find(m => m.id === activeItem.id);

  // Check if it's a subItem
  let subItemTranslation = null;
  for (const m of menu) {
    if (m.subItems) {
      const sub = m.subItems.find(si => si.id === activeItem.id);
      if (sub) {
        subItemTranslation = i18n.t(sub.name, { ns: 'navigation' });
        break;
      }
    }
  }

  trackCustomGA4Event('time_spent_per_page', {
    menu_id: activeItem.id,
    menu_name: topMenu ? i18n.t(topMenu.name, { ns: 'navigation' }) : subItemTranslation,
    duration_seconds: durationSeconds,
    display_language: i18n.language
  });
}

export default reportMenuDuration;
